import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Constant } from './constants';
import { Observable, BehaviorSubject, of, Subject, map, catchError, firstValueFrom } from 'rxjs';
import * as fromModel from './models';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as fromModelshared from '../../modules/shared/models';
import { MsalService } from '@azure/msal-angular';


export class UserDetail {
  name = '';
  userid = '';
  poolIds = '';
  repId = '';
  simulateRepIds = '';
  role = fromModel.USERROLE.FA;
}
@Injectable({
  providedIn: 'root'
})
export class UserService {
  appInsights: ApplicationInsights = new ApplicationInsights({ config: { instrumentationKey: Constant.config.appInsightKey } });

  private sessionId = '';
  private app: string = 'Supervision Tool -> ';
  private step = 0;
  private user: UserDetail | undefined;
  private simUser: UserDetail | undefined;
    jwtHelperSvc: JwtHelperService | undefined;
    

  public userSubject = new BehaviorSubject<UserDetail | undefined>(undefined);
  private isdatamarkingon = false;

  constructor(private _httpClient: HttpClient,
    private route: ActivatedRoute,
      private authService: MsalService,
  ) {
    const _hash = window.location.hash;
    if (_hash && _hash.trim().toUpperCase().includes("DATAMASK=Y") || _hash.trim().toUpperCase().includes("DATAMASK='Y'")) {
      this.isdatamarkingon = true;
    }
    this.sessionId = (new Date()).getTime().toString();
    this.app += ' Session Id:' + this.sessionId + ' ';
  }



  getToken(): Observable<string | undefined> {
    const account = this.authService.instance.getActiveAccount()
      ?? this.authService.instance.getAllAccounts()?.[0]
      ?? null;

    if (!account) {
      return of(undefined);
    }

    const scopes = (Constant.config.scopes && Constant.config.scopes.length > 0)
      ? Constant.config.scopes
      : (Constant.config.scope ? [Constant.config.scope] : []);

    if (scopes.length === 0) {
      return of(undefined);
    }

    return this.authService.acquireTokenSilent({
      account,
      scopes,
    }).pipe(
      map(tokenResponse => tokenResponse.accessToken),
      catchError(error => {
        console.error('Token Acquisition Error:', error);
        return of(undefined);
      })
    );
  }


async getTokenAsync(): Promise<string | undefined> {
  return await firstValueFrom(this.getToken());
}
    async  getUserNameFromSession() :Promise<UserDetail | undefined> {
          let idtoken = sessionStorage.getItem('msal.idtoken');
         
          if(!idtoken) {
           idtoken = await this.getTokenAsync() ?? null;
             
           sessionStorage.setItem('msal.idtoken', idtoken ?? '');
          }
          if (!this.jwtHelperSvc) {
            this.jwtHelperSvc = new JwtHelperService();
          }
          if (idtoken) {
            const decodedToken = this.jwtHelperSvc.decodeToken(idtoken);
         
              console.log("***********************************GET USER NAME****************************");
              let _u = new UserDetail();
              _u.name = decodedToken.name || '';
              _u.userid = decodedToken.preferred_username || '';
              _u.poolIds = decodedToken.poolIds || '';
              _u.repId = decodedToken.primaryid || '';
      
              if (decodedToken.roles) {
                console.log("Roles: " + JSON.stringify(decodedToken.roles));
                this.traceMsg("Supervision UI. Roles: " + JSON.stringify(decodedToken.roles));
              } else {
               this.traceMsg("Supervision UI: Roles not found");
              }
      
              // this.traceMsg("Supervision UI: name: " + _u.name + " T:" + idtoken);
      
              // if (decodedToken.roles && decodedToken.roles.length > 0) {
              //   if (decodedToken.roles.includes(fromModelshared.USERROLE.SUPERUSER)) {
              //     _u.role = fromModelshared.USERROLE.SUPERUSER;
              //   } else if (decodedToken.roles.includes(fromModel.USERROLE.COMPUSER)) {
              //     _u.role = fromModel.USERROLE.COMPUSER;
              //   } else if (decodedToken.roles.includes(fromModel.USERROLE.FA)) {
              //     _u.role = fromModel.USERROLE.FA;
              //   } else if (decodedToken.roles.includes(fromModel.USERROLE.CA)) {
              //     _u.role = fromModel.USERROLE.CA;
              //   } else if (decodedToken.roles.includes(fromModel.USERROLE.MANAGER)) {
              //     _u.role = fromModel.USERROLE.MANAGER;
              //   }
              // }
            return _u;
          
          }

          return undefined;
        }


  setUser(u: UserDetail) {
    this.user = u;
    this.userSubject.next(u);
  }

  setSimUser(role: fromModel.USERROLE) {
    this.simUser = JSON.parse(JSON.stringify(this.user));
    if (this.simUser) {
      this.simUser.role = role;
      this.userSubject.next(this.simUser);
    }
  }

  getUser(): UserDetail | undefined {
    return this.user;
  }

  setdatamasking(val: boolean) {
    this.isdatamarkingon = val;
  }
  getdatamasking(): boolean {
    return this.isdatamarkingon;
  }

  getTestData(): Observable<any> {
    const d: any = {
      actNo: 'RJM',
      mktVal: 123456,
      owner: 'Test Client',
      actType: 'Test Account Type',
      state: 'NJ',
      taxStatus: 'Taxable',
      turnOver: 6
    };
    let _data: any[] = [];
    for (let i = 0; i < 10000; i++) {
      let k = Object.assign({}, d);
      k.actNo = k.actNo + i.toString();
      _data.push(k);
    }
    return of(_data);
  }


  

  // -------- Tracing -------------
  // Information, Verbose, Warning, Error, Critical
  traceMsg(msg: string, detail?: any, level: string = "Information"): void {

    this.step = this.step + 1;
    // this.appInsightsService.trackTrace(this.app + msg, {
    //   'userId': this.user?.userid || '', 'sessionId': this.sessionId, 'step': this.step.toString(),
    //   'datail': JSON.stringify(detail)
    // }, SeverityLevel.Information);

    this.appInsights.trackTrace({ message: this.app + msg }, { 'userId': this.user?.userid, 'sessionId': this.sessionId, 'datail': JSON.stringify(detail) });
    this.flushMessages();
  }

  // traceEvent(msg: string, property?: any): void {
  //   this.appInsightsService.trackEvent(this.app + msg, property)
  // }

  // traceException(err: Error): void {
  //   this.appInsightsService.trackException(err);
  // }

  // flushMessages() {
  //   this.appInsightsService.flush();
  // }

  traceException(err: Error): void {
    this.appInsights.trackException({ exception: err });
  }

  flushMessages() {
    this.appInsights.flush();
  }
  // -------- Tracing End -------

}
